import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadUsers () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
      ...{
        'exists[youtubeVideoId]': true,
        'order[videoStatus]': 'ASC',
      },
    })

    api.get('users', { params })
      .then(result => {
        this.users = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  playVideo (user) {
    this.videoPlaying = user
    this.showVideoDialog = true
  },

  updateVideoStatus (user, status) {
    const api = getApiClient(this.$store)

    api.patch(`/user/teacher/${user.id}/review_video`,
      { videoStatus: status },
      { headers: { 'Content-Type': 'application/merge-patch+json' } },
    )
      .then(result => {
        user.videoStatus = status
        user.videoReviewer = result.data.videoReviewer
      })
      .catch(error => {
        this.error = error
      })
      .finally(() => {
        this.videoPlaying = {}
        this.showVideoDialog = false
      })
  },

  closeVideoDialog () {
    this.videoPlaying = {}
    this.showVideoDialog = false
  },

  clearFilters () {
    this.filters = {}
    this.loadUsers()
  },
}
